<template>
      <div>
         <breadcrumb :routerList="[{to:'/guanhuai',title:'交互计划'},{title:'过期拜访'}]"/>
         <div class="h-piece">
            <div class="h-pieceTitle2" >
               <h1>交互计划</h1>
            </div>
            <div class="right">
               <el-form  label-position=right ref="formLabelAlign3" :model="formLabelAlign3" :inline="true"  class="demo-ruleForm h-formbLine">
                    <el-form-item label="拜访客户" class="h-elformWrap-2">
					<span class="h-readOnlyTxt">{{formLabelAlign3.euName}}</span>
				  </el-form-item>
				 <el-form-item label="客户类型" class="h-elformWrap-2">
					<span class="h-readOnlyTxt"><dictname category="userCareType" :v="formLabelAlign3.euType"/></span>
				  </el-form-item>

				  <el-form-item label="区域" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
						{{formLabelAlign3.areaCode | dictname('YLRegion')}}
				  </el-form-item>
				  <el-form-item label="用户渠道" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
						{{formLabelAlign3.channelCode | dictname('sales_region')}}
				  </el-form-item>
                  <el-form-item label="拜访时间" class="h-elformWrap-2">
					<span class="h-fl">
					  <span class="h-readOnlyTxt">{{formLabelAlign3.planTimeStart}}</span>
					</span>
					<el-col class="line h-txtCenter" :span="2">至</el-col>
					<span class="h-fl">
					  <span class="h-readOnlyTxt">{{formLabelAlign3.planTimeEnd}}</span>
					</span>
				  </el-form-item>
                    <el-form-item class="h-elformWrap-2" label="提报时间">
                    <span class="h-fl">
                    <span class="h-readOnlyTxt">{{formLabelAlign3.ldate}}</span>
                    </span>
                    </el-form-item>
               </el-form>
            </div>
         </div>
         <div class="h-piece">
            <div class="h-pieceTitle2" >
               <h1>用户信息</h1>
            </div>
            <div class="right">
               <el-form  label-position=right ref="formLabelAlign3" :model="formLabelAlign3" :inline="true"  class="demo-ruleForm h-formbLine">
                    <el-form-item label="部门/科室" class="h-elformWrap-1">
                    <span class="h-readOnlyTxt">{{formLabelAlign3.contactDept}}</span>
                    </el-form-item>
                    <el-form-item label="关键人" class="h-elformWrap-1">
                    <span class="h-readOnlyTxt">{{formLabelAlign3.contact}}</span>
                    </el-form-item>
                    <el-form-item label="联系方式" class="h-elformWrap-1">
                    <span class="h-readOnlyTxt">{{formLabelAlign3.contactPhone}}</span>
                    </el-form-item>
                    <el-form-item label="洽谈内容" prop="formCon10" class="h-elformWrap-1">
                    <span class="h-readOnlyTxt">{{formLabelAlign3.planRemark}}</span>
                    </el-form-item>
               </el-form>
            </div>
         </div>
         <div class="h-piece">
            <div class="h-pieceTitle2" >
               <h1>过期原因</h1>
            </div>
            <div class="right">
               <el-form  label-position=right ref="formLabelAlign3" :model="formLabelAlign3" :inline="true"  class="demo-ruleForm h-formbLine">
                    <el-form-item class="h-elformWrap-1" prop="explain">
                        <el-input type="textarea" v-model="formLabelAlign3.remark" style="height: 27px;"></el-input>
                    </el-form-item>
               </el-form>
            </div>
         </div>
         <div class="h-piece">
            <div class="h-pieceTitle2" >
               <h1>审核意见</h1>
            </div>
            <div class="right">
               <el-form  label-position=right ref="formLabelAlign3" :model="formLabelAlign3" :inline="true"  class="demo-ruleForm h-formbLine">
                    <el-form-item class="h-elformWrap-1" prop="explain">
                        <span class="h-readOnlyTxt">{{formLabelAlign3.checkMsg}}</span>
                    </el-form-item>
               </el-form>
            </div>
         </div>

            <div class="h-txtCenter h-mrt60">
                <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="cancel">返回</el-button>
                <el-button  style="pass" class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="submitReasonOrChange">提交</el-button>
            </div>
      </div>
</template>
<style scoped>
   .right{
      margin-left: 12px;
   }
   .zhonglu{
      margin-left: -36px;
   }
   .n-bu{
      border:1px solid rgb(206, 204, 204)
   }
   .h-piece {
      margin: 20px;
   }
   .h1 {
      margin-left: 27px;
   }
   .n-xiao .h-formbLine .h-elformWrap-2,
   .n-two .h-formbLine .h-elformWrap-2 {
      width: 33.333%;
   }
   .el-cascader {
      line-height: normal;
   }
</style>
<style>
    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }

    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 27%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 73%;
    }

</style>
<style scoped>
.mubiaoBox{
	display: flex;
	justify-content: center;
}
.mubiaoBox .mubiao{
	display: flex;
	justify-content: center;
	align-items: center;
}
.mubiaoBox .mubiao .mubiaobutton{
	width: 30px;
	height: 18px;
	background: #4f8bfe;
}
.mubiaoBox .mubiao .mubiaotext{
	margin-left: 20px;
	color: #595959;
	font-size: 14px;
}
.weekplans .h-formBorder .el-input__inner{
    border: 0;
    border-bottom: 1px solid #d1d1d1;
}
.weekplans .h-formBorder .el-form-item__content{
    width: 70%;
}
.h-formbLine .el-form-item__label {
    width: 20%;
}
.pass {
    background-color: #006aca;
    color: white;
    width: 18%;
}

.refuse {
    background-color: #24b5b8;
    color: white;
    width: 18%;
}
</style>
<script>
    import ss from '../../api/SystemService'

    export default {

        //页面加载前事件
        created() {
        },

        methods: {
            tibaobut(){
                if(this.$route.query.taskstatus==0){
                    this.zstype=true;
                }
                var id=this.$route.query.ywid;
				ss.UserCare.planDetail({id:id}).then(rd => {
					console.log(rd,"提报原因右边图表下");
					this.formLabelAlign3=rd.plan;
                })
                this.formLabelAlign3.taskid=this.$route.query.taskid;
            },
            //用户提交
        submitReasonOrChange(v){
				//过期未执行提报原因
				console.log(this.formLabelAlign3,"过期未执行提报原因");
				let msg="确认修改计划？";
				var subflag=true;
                msg="确认提报原因？";
                if(!this.formLabelAlign3.remark){
                    this.$msg.msge("请填写提报原因");
                    this.$refs['formLabelAlign3'].validate((valid) => {
                        return valid;
                    })
                    subflag=false;
                }
                this.formLabelAlign3.planStatus=4;//提交
				if(subflag){
					this.$msg.confirm(msg,()=>{
						ss.UserCare.updateById(this.formLabelAlign3).then(rd => {
							console.log(rd,"右边图表下");
							this.$msg.msgs("提交成功");
							this.dialogFormVisible1=false;
                            this.dialogFormVisible2=false;
                            this.$router.push("/guanhuai");
                            this.$store.dispatch('searchTasktotal');
						})
					})
				}
			},
         //取消按钮
        cancel() {
            this.$router.go(-1);
        },
        },
        mounted() {
                this.tibaobut();
            },
        data() {
            return {
                formLabelAlign3:{},
                formLabelAlign:{},
                zstype:false,
                flaag: true,
            };
        },
    }

</script>


